var quickViewCheck = 0
window.loadedQuickView  = setInterval(function () {

  if (window.jQuery !== undefined) {
    
    window.quickView = {
      /**
       * @summary Initializes the quickview functionaliyt
       * 
       * @description Adds event listeners used throughout
       *
       * @return  {void}
       */
      init: function () {
        var self = this;
  
        self.addEventListeners();
      },
  
      /**
       * @summary Adds event listeners
       * 
       * @description Creates the event listeners
       * used throughout this class.
       *
       * @return  {void}
       */
      addEventListeners: function () {
        var self = this;
        
        $(document).on('click', '[data-quickview]', function(e) {
          if( !$(this).hasClass('loading') )
            ($(this).addClass('loading'), self.showModal($(this).data('quickview')));
        });
      },
  
      /**
       * @summary Shows the modal
       * 
       * @description Shows a product modal using the
       * provided product handle. Calls the ajax function
       * to retrieve the HTML for that product.
       *
       * @return  {void}
       */
      showModal: function (productHandle) {
        var self = this;

        $.ajax({
          url      : `/products/${productHandle}?view=ajax-quickview&cache=${ new Date().getMilliseconds() }`,
          success  : function(response) {
            
            var productHtml = $($.parseHTML(response)).find('section.product-template');
            var modal       = self.buildModal();

            modal.find('.modal-body').append(productHtml);
            modal.modal('show');

            modal.on('shown.bs.modal', function (e) {
              $('.carousel-quickview').flickity({
                cellSelector    : ".carousel-quickview-cell",
                wrapAround      : true,
                imagesLoaded    : true,
                pageDots        : false,
                prevNextButtons : false
              });

              $('.carousel-mip-nav-quickview').flickity({
                asNavFor        : ".carousel-quickview",
                contain         : true,
                imagesLoaded    : true,
                pageDots        : false,
                prevNextButtons : false
              })
            });

            modal.on('hidden.bs.modal', function (e) {
              modal.remove();
              $(`[data-quickview="${productHandle}"]`).removeClass('loading');
            });
          },

          // Default error handling
          error : function(res) {
            console.log('QuickView Error: ', err);
          }
        });
      },

      /**
       * @summary Builds the modal
       * 
       * @description Defines and builds the html used
       * in the modal.
       *
       * @return  {object} THe parsed jQuery element
       */
      buildModal: function () {
        return $($.parseHTML(`
          <!-- Modal -->
          <div class="quickview-modal modal fade" 
              id="quickview-modal"
              tabindex="-1"
              role="dialog"
              aria-labelledby="quickViewModalLabel"
              aria-hidden="true"
              style="z-index: 10000;">
          
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <span class="modal-title text-center" id="quickViewModalLabel">Select Options</span>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">
                      <svg style="width: 20px; height: 20px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.37 19.4"><line x1="0.71" y1="18.69" x2="18.66" y2="0.74" style="fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px"/>
                        <line x1="0.71" y1="0.71" x2="18.66" y2="18.66" style="fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px"/>
                      </svg>
                    </span>
                  </button>
                </div>
                <div class="modal-body p-0"></div>
              </div>
            </div>
          </div>`)[3]);
      },
    };

    
    // Initialize quickview
    quickView.init();
    clearInterval(window.loadedQuickView);
  }

  if (quickViewCheck >= 15)
    (console.log('Error! - Could not load quickview.'), clearInterval(window.loadedQuickView));
  
  quickViewCheck++;
}, 300);